
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLinkedinBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 29,
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.567 2.86v22.746a1.961 1.961 0 0 1-1.961 1.96H2.86A1.96 1.96 0 0 1 .9 25.607V2.86A1.96 1.96 0 0 1 2.86.9h22.746a1.96 1.96 0 0 1 1.96 1.96ZM8.743 11.097H4.821v12.55h3.922v-12.55Zm.353-4.314a2.259 2.259 0 0 0-2.243-2.274h-.07a2.275 2.275 0 0 0 0 4.549 2.259 2.259 0 0 0 2.313-2.204v-.07Zm14.549 9.24c0-3.773-2.4-5.24-4.784-5.24a4.472 4.472 0 0 0-3.969 2.024h-.11v-1.71h-3.686v12.55h3.921V16.97a2.604 2.604 0 0 1 2.354-2.808h.149c1.247 0 2.172.784 2.172 2.76v6.722h3.922l.031-7.623Z",
  stroke: "#000",
  strokeWidth: 1.8,
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"29\" height=\"29\" viewBox=\"0 0 29 29\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M27.5666 2.86081V25.6059C27.5666 26.1259 27.3599 26.6247 26.9922 26.9924C26.6246 27.3602 26.1258 27.5667 25.6058 27.5667H2.86069C2.34065 27.5667 1.84192 27.3602 1.4742 26.9924C1.10649 26.6247 0.899902 26.1259 0.899902 25.6059V2.86081C0.899902 2.34077 1.10649 1.84204 1.4742 1.47433C1.84192 1.10661 2.34065 0.900024 2.86069 0.900024H25.6058C26.1258 0.900024 26.6246 1.10661 26.9922 1.47433C27.3599 1.84204 27.5666 2.34077 27.5666 2.86081ZM8.74304 11.0961H4.82148V23.6451H8.74304V11.0961ZM9.09598 6.78237C9.09805 6.48574 9.04166 6.19161 8.93005 5.91676C8.81845 5.64192 8.6538 5.39174 8.44549 5.18054C8.2372 4.96933 7.98934 4.80121 7.71608 4.6858C7.44281 4.57038 7.14948 4.50992 6.85285 4.50786H6.78225C6.17902 4.50786 5.60049 4.7475 5.17393 5.17405C4.74738 5.60061 4.50774 6.17914 4.50774 6.78237C4.50774 7.38561 4.74738 7.96414 5.17393 8.3907C5.60049 8.81725 6.17902 9.05689 6.78225 9.05689C7.07892 9.06418 7.3741 9.01296 7.65094 8.90613C7.9278 8.79932 8.18089 8.63898 8.39576 8.43432C8.61062 8.22965 8.78306 7.98464 8.90321 7.7133C9.02336 7.44197 9.08886 7.14962 9.09598 6.85297V6.78237ZM23.645 16.0216C23.645 12.2491 21.245 10.7824 18.8607 10.7824C18.0801 10.7433 17.3027 10.9096 16.6063 11.2646C15.9101 11.6196 15.3189 12.1511 14.8921 12.8059H14.7822V11.0961H11.096V23.6451H15.0175V16.9706C14.9609 16.2871 15.1762 15.6087 15.6167 15.083C16.0573 14.5572 16.6875 14.2266 17.3705 14.1628H17.5195C18.7666 14.1628 19.6921 14.9471 19.6921 16.9235V23.6451H23.6137L23.645 16.0216Z\" stroke=\"black\" stroke-width=\"1.8\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/linkedin-black.c19d3e5e834d80083e4cca9cdc331393.svg"),
        {
          React: SvgLinkedinBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      